// types/icons.ts
import { Cpu, Code, Factory, Wrench, HeadphonesIcon, GraduationCap, ArrowRight, Book, Presentation, FileCog, MonitorCog, ListCheck } from "lucide-react";

export const iconMap = {
  Cpu,
  Code,
  Factory,
  Wrench,
  HeadphonesIcon,
  GraduationCap,
  ArrowRight,
  Book, 
  Presentation, 
  FileCog, 
  MonitorCog, 
  ListCheck
} as const;

export type IconKey = keyof typeof iconMap;